/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Seo_DescInputs */

const en_svc_seo_desc = /** @type {(inputs: Svc_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI agents, voice agents, chat bots, RAG assistants, MCP servers, MVP sprints, automation, scraping, programmatic SEO, full-stack, mobile and retainers. Contact for a quote.`)
};

const ar_svc_seo_desc = /** @type {(inputs: Svc_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وكلاء الذكاء الاصطناعي، الوكلاء الصوتيون، بوتات المحادثة، مساعدو RAG، خوادم MCP، سباقات MVP، الأتمتة، السكرابينغ، السيو البرمجي، full-stack، الجوال وعقود الصيانة. تواصل لعرض السعر.`)
};

const bn_svc_seo_desc = /** @type {(inputs: Svc_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI এজেন্ট, ভয়েস এজেন্ট, চ্যাট বট, RAG অ্যাসিস্ট্যান্ট, MCP সার্ভার, MVP স্প্রিন্ট, অটোমেশন, স্ক্র্যাপিং, প্রোগ্রাম্যাটিক SEO, ফুল-স্ট্যাক, মোবাইল ও রিটেইনার। কোটেশনের জন্য যোগাযোগ করুন।`)
};

const de_svc_seo_desc = /** @type {(inputs: Svc_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Agenten, Voice-Agenten, Chat-Bots, RAG-Assistenten, MCP-Server, MVP-Sprints, Automatisierung, Scraping, programmatisches SEO, Full-Stack, Mobile und Retainer. Kontaktieren Sie uns für ein Angebot.`)
};

const es_svc_seo_desc = /** @type {(inputs: Svc_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes de IA, agentes de voz, chatbots, asistentes RAG, servidores MCP, sprints MVP, automatización, scraping, SEO programático, full-stack, móvil y retainers. Contacte para una cotización.`)
};

const fr_svc_seo_desc = /** @type {(inputs: Svc_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents IA, agents vocaux, chatbots, assistants RAG, serveurs MCP, sprints MVP, automatisation, scraping, SEO programmatique, full-stack, mobile et forfaits. Contactez pour un devis.`)
};

const pt_svc_seo_desc = /** @type {(inputs: Svc_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes de IA, agentes de voz, chatbots, assistentes RAG, servidores MCP, sprints MVP, automação, scraping, SEO programático, full-stack, mobile e avenças. Entre em contato para um orçamento.`)
};

const zh_svc_seo_desc = /** @type {(inputs: Svc_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 智能体、语音助手、聊天机器人、RAG 助手、MCP 服务器、MVP 冲刺、自动化、抓取、程序化 SEO、全栈、移动端和包月维护。联系获取报价。`)
};

const tr_svc_seo_desc = /** @type {(inputs: Svc_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YZ ajanları, sesli asistanlar, sohbet botları, RAG asistanları, MCP sunucuları, MVP sprintleri, otomasyon, scraping, programatik SEO, full-stack, mobil ve retainer. Teklif için iletişime geçin.`)
};

const ru_svc_seo_desc = /** @type {(inputs: Svc_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ-агенты, голосовые ассистенты, чат-боты, RAG-ассистенты, MCP-серверы, MVP-спринты, автоматизация, скрапинг, программное SEO, фулстек, мобайл и ретейнеры. Свяжитесь для расчёта.`)
};

const pl_svc_seo_desc = /** @type {(inputs: Svc_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenci AI, agenci głosowi, chatboty, asystenci RAG, serwery MCP, sprinty MVP, automatyzacja, scraping, programatyczne SEO, full-stack, mobile i retainer. Napisz po wycenę.`)
};

/**
* | output |
* | --- |
* | "AI agents, voice agents, chat bots, RAG assistants, MCP servers, MVP sprints, automation, scraping, programmatic SEO, full-stack, mobile and retainers. Conta..." |
*
* @param {Svc_Seo_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_seo_desc = /** @type {((inputs?: Svc_Seo_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Seo_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_seo_desc(inputs)
	if (locale === "bn") return bn_svc_seo_desc(inputs)
	if (locale === "de") return de_svc_seo_desc(inputs)
	if (locale === "es") return es_svc_seo_desc(inputs)
	if (locale === "fr") return fr_svc_seo_desc(inputs)
	if (locale === "pt") return pt_svc_seo_desc(inputs)
	if (locale === "zh") return zh_svc_seo_desc(inputs)
	if (locale === "tr") return tr_svc_seo_desc(inputs)
	if (locale === "ru") return ru_svc_seo_desc(inputs)
	if (locale === "pl") return pl_svc_seo_desc(inputs)
	return en_svc_seo_desc(inputs)
});